import { Grid } from '#app/components/Grid/Grid.js';
import { css, styled } from 'styled-components';

export const RelativePositionContainer = styled.div`
  position: relative;
`;

export const Section = styled(Grid)`
  ${({ theme }) => css`
    margin: 0;
    padding: 0 16px;

    max-width: 1376px;

    ${theme.mediaQueries.md} {
      padding: 0 32px;
    }
  `}
`;

export const Main = styled.main`
  flex: 1;
`;

export const ProfileBody = styled.div`
  display: flex;
  gap: 40px;
  padding-top: 0;
  flex: 1;
  margin-bottom: 32px;
  min-width: unset;
  position: relative;
`;

export const ProfileContent = styled.div`
  flex-grow: 1;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
